/**
 * Proposal — renderer (frontend). Same shape as PurchaseOrder.tsx.
 * Reads the snapshot payload produced by backend/document-sharing/types/proposal.js.
 */
import type { DocumentProps, FrontendDocumentDefinition } from '../registry';
import { BaseDocumentLayout } from '../BaseDocumentLayout';

function formatCurrency(value: any): string {
  const n = typeof value === 'number' ? value : Number(value);
  if (!isFinite(n)) return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n);
}

const MUTED = 'rgb(var(--gray-500))'; // was #6b7280 — exact match to --gray-500 token

export const documentDefinition: FrontendDocumentDefinition = {
  docType: 'proposal',
  renderer: Proposal,
  appRoute: '/leads/proposals',
};

export function Proposal({ payload }: DocumentProps) {
  const prop = payload?.proposal || {};
  const lead = payload?.lead || null;

  return (
    <BaseDocumentLayout
      title="PROPOSAL"
      reference={prop.name}
      meta={[{ label: 'Status', value: prop.status }]}
    >
      <div style={{ marginBottom: 20 }}>
        {/* gap: this field-label style (fontSize 11 / uppercase / marginBottom 4) is
            repeated identically across all 6 document templates — candidate for a
            shared "doc field label" token/class, not added here per scope. */}
        <div style={{ fontSize: 11, textTransform: 'uppercase', color: MUTED, marginBottom: 4 }}>Client</div>
        <div style={{ fontWeight: 600 }}>{lead?.name || 'Client'}</div>
        {lead?.email && <div style={{ color: MUTED }}>{lead.email}</div>}
      </div>

      {prop.content && <div style={{ whiteSpace: 'pre-wrap', marginBottom: 20 }}>{prop.content}</div>}

      {/* gap: this footer total block (border-top 2px + paddingTop 12, fontSize 20/700
          value) is repeated identically across 5 of 6 document templates (all but
          Warranty) — candidate for a shared "doc total footer" token/component. */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', borderTop: '2px solid rgb(var(--gray-900))', paddingTop: 12 }}>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 11, textTransform: 'uppercase', color: MUTED }}>Total</div>
          <div style={{ fontSize: 20, fontWeight: 700 }}>{formatCurrency(prop.total_amount)}</div>
        </div>
      </div>
    </BaseDocumentLayout>
  );
}
